import { useEffect, useState, useRef } from "react";
import { ChevronLeftIcon, ChevronRightIcon } from "@heroicons/react/24/outline";
import ItemReviewCard from "./ItemReviewCard";
import { getReview } from "../../services/firestore/servicesService";

export default function ItemReviewList({ serviceData }) {
  const [reviews, setReviews] = useState([]);
  const scrollContainerRef = useRef(null);

  useEffect(() => {
    const getReviewData = async () => {
      if (!serviceData?.id) return;
      const responseData = await getReview(serviceData.id);
      console.log(responseData)
      setReviews(responseData);
    };
    getReviewData();
  }, [serviceData]);

  const scroll = (direction) => {
    const container = scrollContainerRef.current;
    if (!container) return;
    const scrollAmount = container.offsetWidth * 0.8; // scroll roughly one viewport width
    container.scrollBy({
      left: direction === "left" ? -scrollAmount : scrollAmount,
      behavior: "smooth",
    });
  };

  if(reviews?.length === 0) return null;

  return (
    <div className="relative w-full mt-4">
      <h2 className="text-xl font-semibold mb-4">Customer Reviews</h2>

      {/* Scroll Buttons */}
      <button
        onClick={() => scroll("left")}
        className="absolute left-0 top-1/2 -translate-y-1/2 z-10 bg-white/80 hover:bg-white p-2 my-4 rounded-full shadow-md"
      >
        <ChevronLeftIcon className="w-5 h-5" />
      </button>
      <button
        onClick={() => scroll("right")}
        className="absolute right-0 top-1/2 -translate-y-1/2 z-10 bg-white/80 hover:bg-white p-2 my-4 rounded-full shadow-md"
      >
        <ChevronRightIcon className="w-5 h-5" />
      </button>

      {/* Scrollable Review List */}
      <div
        ref={scrollContainerRef}
        className="flex gap-4 overflow-x-auto scroll-smooth snap-x snap-mandatory px-10 py-4 scrollbar-hide"
      >
        {reviews.length === 0 ? (
          <p className="text-gray-500"></p>
        ) : (
          reviews.map((review) => (
            <ItemReviewCard key={review.id} review={review} />
          ))
        )}
      </div>
    </div>
  );
}
